import { GridImage } from "../../components/PhotoGrid/types";
import {CornerFrontRight} from "./images/CornerFrontRight";
import {CornerFrontLeft} from "./images/CornerFrontLeft";
import {CornerRearRight} from "./images/CornerRearRight";
import {CornerRearLeft} from "./images/CornerRearLeft";

export const SAMPLE_PHOTOS = [
  {
    id: "1",
    component: CornerFrontLeft,
    alt: "Car from front left corner",
  },
  {
    id: "2",
    component: CornerFrontRight,
    alt: "Car from front right corner",
  },
  {
    id: "3",
    component: CornerRearRight,
    alt: "Car from rear right corner",
  },
  {
    id: "4",
    component: CornerRearLeft,
    alt: "Car from rear left corner",
  },
] as GridImage[];

export const FILES_TO_ACCEPT = {
  "image/*": [".png", ".gif", ".jpeg", ".jpg"],
};
